import { IconButton, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useState } from 'react';
import DownloadProgress from './DownloadProgress';

const Download = ({ application }) => {
  const axiosPrivate = useAxiosPrivate();
  const [isDownloading, setIsDownloading] = useState(false);
  const [percent, setPercent] = useState(null);   // null = size not known yet (spinner)

  const handleDownload = async () => {
    if (!application?._id || isDownloading) return;

    setIsDownloading(true);
    setPercent(null);

    try {
      const response = await axiosPrivate.get(`/api/applications/${application._id}/download`, {
        responseType: 'blob',
        onDownloadProgress: (e) => {
          // Use the Content-Length from the server, or the file size stored in the database
          const total = e.total || application.fileSize;
          if (!total) return;

          setPercent(Math.min(100, Math.round((e.loaded * 100) / total)));
        },
      });

      setPercent(100);

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = application.originalFileName || 'application-file';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file:', error);
    } finally {
      setIsDownloading(false);
      setPercent(null);
    }
  };

  return (
    <Tooltip
      title={
        isDownloading
          ? percent !== null
            ? `Downloading... ${percent}%`
            : 'Downloading...'
          : 'Download Application'
      }
    >
      <span>
        <IconButton
          color="secondary"
          size="small"
          style={{ marginRight: 8 }}
          onClick={handleDownload}
          disabled={isDownloading}
          aria-label="download application"
        >
          {isDownloading ? (
            <DownloadProgress percent={percent} size={30} />
          ) : (
            <DownloadIcon />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default Download;